/**
 * Employee Permissions Provider
 *
 * Wraps the portal app to provide employee permissions context.
 * Fetches the current auth user's linked employee record and permissions.
 */

import type { ReactNode } from "react";

import {
  EmployeePermissionsContext,
  useEmployeePermissionsQuery,
} from "~/hooks/use-employee-permissions";

interface EmployeePermissionsProviderProps {
  children: ReactNode;
}

export function EmployeePermissionsProvider({
  children,
}: EmployeePermissionsProviderProps) {
  const permissionsData = useEmployeePermissionsQuery();

  return (
    <EmployeePermissionsContext value={permissionsData}>
      {children}
    </EmployeePermissionsContext>
  );
}
